module.exports = "/assets/data/aa08dde3dabbff18a1d0be12b83fd62c-N5.data.json";